const MODULE_NAME = 'company';

export function getModuleName(): string {
  return MODULE_NAME;
}
